"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.717.286A.502.502 0 0 0 14.264 0h-2.489v1.002h1.436L8.573 6.704a.497.497 0 0 0-.113.315l-.012 6.437-1.229.994V7.048a.5.5 0 0 0-.11-.312L2.542 1.002h8.052V0H1.501a.5.5 0 0 0-.392.813l5.108 6.41V15.5a.5.5 0 0 0 .817.39l2.23-1.804a.5.5 0 0 0 .185-.388L9.462 7.2l5.19-6.382a.5.5 0 0 0 .065-.531"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.919.32A.562.562 0 0 0 21.41 0h-3.77v1.127h2.592l-7.296 9.023a.567.567 0 0 0-.126.354l-.018 9.913-2.257 1.836v-11.78a.562.562 0 0 0-.123-.352L3.233 1.127h12.613V0H2.063a.563.563 0 0 0-.44.915l7.786 9.756v12.765a.565.565 0 0 0 .917.438l3.381-2.75a.563.563 0 0 0 .209-.437l.018-9.983L21.848.918a.564.564 0 0 0 .07-.597"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.225.428A.75.75 0 0 0 28.548 0h-5.03v1.503h3.457l-9.728 12.03a.756.756 0 0 0-.168.472l-.025 13.218-3.009 2.448V13.963a.75.75 0 0 0-.164-.469L4.311 1.503h16.817V0H2.75a.75.75 0 0 0-.586 1.22l10.381 13.008v17.02a.753.753 0 0 0 .75.752.747.747 0 0 0 .473-.168l4.508-3.667a.75.75 0 0 0 .278-.583l.025-13.31L29.131 1.225a.752.752 0 0 0 .094-.796"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.195.534A.937.937 0 0 0 43.349 0h-7.538v1.88h5.582L26.555 20.397a.943.943 0 0 0-.206.586l-.039 20.085-4.881 4.008V20.921a.942.942 0 0 0-.204-.584L6.628 1.88h25.601V0H4.688a.937.937 0 0 0-.845.531.944.944 0 0 0 .11.994l15.6 19.725v25.81a.941.941 0 0 0 .938.94.936.936 0 0 0 .593-.212l6.757-5.546a.94.94 0 0 0 .343-.726l.039-20.199L44.08 1.53a.942.942 0 0 0 .115-.995"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.926.712A1.25 1.25 0 0 0 57.8 0H47.75v2.507h7.441L35.407 27.196a1.258 1.258 0 0 0-.276.782l-.05 26.78-6.51 5.343V27.896c0-.283-.096-.557-.27-.779L8.836 2.507h34.135V0H6.25c-.48 0-.917.275-1.126.708-.208.433-.152.948.146 1.325l20.801 26.3v34.413A1.255 1.255 0 0 0 27.321 64c.283 0 .563-.096.791-.283l9.01-7.394c.288-.238.457-.593.457-.968l.051-26.932L58.773 2.04c.301-.376.361-.892.153-1.327"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFilter = function IconFilter(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Filter' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Filter"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFilter.sizes = [16, 24, 32, 48, 64];
IconFilter.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFilter;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Filter.js
// module id = 2382
// module chunks = 0